export default "__VITE_ASSET__BMCYr$A___"